import React, { useState } from "react"
import styled from "@emotion/styled"
import FormControl from "@material-ui/core/FormControl/FormControl"
import { InputLabel } from "@material-ui/core"
import Select from "@material-ui/core/Select/Select"
import MenuItem from "@material-ui/core/MenuItem"
import CheckOutlined from "@material-ui/icons/CheckOutlined"
import PlainLink from "../../../components/ui/link"
import * as routes from "../../../library/constants/routes"
import { devices } from "../../../library/constants/styles/responsive"

export const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 10px;
  border-radius: 20px;
  border: solid 1px #979797;
  font-size: 16px;
  line-height: 1.5;

  @media ${devices.xs} {
    font-size: 14px;
  }
`

const PlanContent = styled.div`
  flex: 1;
  margin-bottom: 30px;
`

const PlanFooter = styled.div``

export const PlanTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  text-align: ${({ textAlign = "center" }) => textAlign};
  line-height: 1;
  margin-bottom: 10px;
`
const PlanSubtitle = styled.h2`
  font-size: 16px;
  font-weight: 500;
  text-align: ${({ textAlign = "center" }) => textAlign};
  line-height: 1;
  margin-bottom: 30px;
`

const PlanDescriptionsContainer = styled.div`
  margin-top: 15px;
  margin-bottom: 30px;
  min-height: 10em;
`

const PlanDescription = styled.p`
  text-align: center;
  //min-height: calc(6em * 1.5);

  &:not(:last-of-type) {
    margin-bottom: 5px;
  }
`

const PlanPriceContainer = styled.div`
  margin-bottom: 30px;
  //font-size: 22px;
  min-height: 7em;
  //font-weight: 500;
  text-align: center;
  line-height: 1;

  @media ${devices.xs} {
    font-size: 18px;
  }
`

const PlanCard = ({ plan }) => {
  const [currentPrice, setCurrentPrice] = useState(4.5)
  const [totalPrice, setTotalPrice] = React.useState(0)
  const [seats, setSeats] = useState(50)

  const onSeatsChange = (e) => {
    const seatsNumber = Number(e.target.value)

    setSeats(seatsNumber)

    if (seatsNumber <= 500) {
      setCurrentPrice(4.5)
      setTotalPrice(4.5 * seatsNumber)
    } else if (seatsNumber <= 2500) {
      setCurrentPrice(4)
      setTotalPrice(4 * seatsNumber)
    } else if (seatsNumber <= 6000) {
      setCurrentPrice(3.5)
      setTotalPrice(3.5 * seatsNumber)
    } else {
      setCurrentPrice(3)
      setTotalPrice(3 * seatsNumber)
    }
  }

  return (
    <PlanContainer>
      <PlanContent>
        <PlanTitle>{plan.title}</PlanTitle>
        <PlanSubtitle as={"h3"}>{plan.subtitle}</PlanSubtitle>
        <PlanPriceContainer>
          {plan.calculation ? (
            <div className={"f fdc aic"}>
              <p className={"font-weight-500 font-20"}>
                ${currentPrice.toFixed(2)}/seat monthly
              </p>
              <p className={"font-weight-500 font-16"}>
                ${(currentPrice * Number(seats)).toFixed(2)}/month total
              </p>
              {/*<p className={"mt5 mb5"}>or</p>*/}
              {/*<p className={"font-weight-500 font-20"}>*/}
              {/*  ${(currentPrice * 10).toFixed(2)}/seat yearly*/}
              {/*</p>*/}
              {/*<p className={"font-weight-500 font-16"}>*/}
              {/*  ${(currentPrice * 10 * Number(seats)).toFixed(2)} total*/}
              {/*</p>*/}
              <FormControl className={"mt30"}>
                <InputLabel id={"seats-number"}>Number of seats</InputLabel>
                <Select
                  labelId={"seats-number"}
                  name="seats"
                  value={seats}
                  onChange={onSeatsChange}
                >
                  {plan.calculation.options.map((o) => (
                    <MenuItem value={o} key={o}>
                      {o}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          ) : (
            <>
              <p className={"font-weight-500 font-20"}>{plan.price} monthly</p>
              {/*<p className={"mt5 mb5"}>or</p>*/}
              {/*<p className={"font-weight-500 font-20"}>*/}
              {/*  {plan.yearPrice} yearly*/}
              {/*</p>*/}
            </>
          )}
        </PlanPriceContainer>
        <PlanDescriptionsContainer>
          <PlanDescription>{plan.description}</PlanDescription>
          <PlanDescription className={"color-black-54 font-14"}>
            {plan.description2}
          </PlanDescription>
        </PlanDescriptionsContainer>

        <p className={"mb15 font-weight-500 font-18"}>
          {plan.featuresBlockTitle}
        </p>
        <div className={"mb30"}>
          {plan.features.map((f) => (
            <div className={"mb15 f"} key={f}>
              <CheckOutlined color={"primary"} className={"mr15"} />
              <span>{f}</span>
            </div>
          ))}
        </div>
        {/*{!!plan.comingSoonFeatures.length && (*/}
        {/*  <>*/}
        {/*    <PlanTitle*/}
        {/*      as={"p"}*/}
        {/*      textAlign={"left"}*/}
        {/*      className={"mb15"}*/}
        {/*    >*/}
        {/*      Coming soon*/}
        {/*    </PlanTitle>*/}
        {/*    <div>*/}
        {/*      {plan.comingSoonFeatures.map((f) => (*/}
        {/*        <p className={"mb10"} key={f}>*/}
        {/*          {f}*/}
        {/*        </p>*/}
        {/*      ))}*/}
        {/*    </div>*/}
        {/*  </>*/}
        {/*)}*/}
      </PlanContent>
      <PlanFooter>
        <p className={"mb15 font-weight-500 font-18"}>See more</p>
        {/*<PlainLink to={routes.CONTACT_FORM} className={"mb5"}>*/}
        {/*  Online tutorials*/}
        {/*</PlainLink>*/}
        <PlainLink to={routes.CONTACT_FORM}>Customer support</PlainLink>
      </PlanFooter>
    </PlanContainer>
  )
}

export default PlanCard
